class BrandParallax extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('.brand-parallax__image');
    this.intensity = (parseFloat(this.dataset.intensity) || 0) / 100;
    this.isVisible = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  connectedCallback() {
    if (!this.image || this.intensity === 0 || this.reducedMotion) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.isVisible = entry.isIntersecting;
      });
      if (this.isVisible) this.update();
    });
    this.observer.observe(this);

    this.onScroll = typeof throttle === 'function' ? throttle(() => this.update(), 15) : () => this.update();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }

  update() {
    if (!this.isVisible) return;
    const rect = this.getBoundingClientRect();
    const viewportCenter = window.innerHeight / 2;
    const elementCenter = rect.top + rect.height / 2;
    const offset = (viewportCenter - elementCenter) * this.intensity;
    this.image.style.setProperty('--parallax-offset', `${offset.toFixed(1)}px`);
  }
}

customElements.define('brand-parallax', BrandParallax);
